import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const supabaseUrl = "https://kskhouhznjvmejixzlbv.supabase.co";
const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imtza2hvdWh6bmp2bWVqaXh6bGJ2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzMwMTA0NzcsImV4cCI6MjA0ODU4NjQ3N30.8EcZRNvLg-4VfKD4kCs960TCqcvYI856dWfHfdiUj1M";

export const supabase = createClient<Database>(supabaseUrl, supabaseKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});